import { mapState } from 'vuex'

import { Card, Button } from 'element-ui'

import { GET_CATALOG } from '@/store/search/constants'

export default {
  name: 'result',
  computed: {
    ...mapState({
      search: state => state.search
    })
  },
  methods: {
    fetchData () {
      this.$store.dispatch('search/' + GET_CATALOG, { id: this.$route.params.id })
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    elCard: Card,
    elButton: Button
  }
}



// WEBPACK FOOTER //
// ./src/components/Catalog/Catalog.js